module.exports = __webpack_public_path__ + "img/ahorro-electrico.3f27b058.svg";